export default {
    moneyFormat: (val) => val.toString().replace(/(?!^)(?=(?:\d{3})+(?:\.|$))/gm, ',') + " <span>تومان</span>",
    currentTime: () => Math.floor(Date.now() / 1000),
}